import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/data';

export default function FeaturedSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            精选<strong className="text-primary-500">专题</strong>推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑团队为你精心策划的漫画专题，帮你发现更多精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group cursor-pointer rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors ${
                index === 0 ? 'md:row-span-2 md:col-span-1' : ''
              }`}
            >
              <div
                className={`relative overflow-hidden ${
                  index === 0 ? 'h-[300px] md:h-[420px]' : 'h-[180px]'
                }`}
              >
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 韩漫屋免费韩漫`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                  <span className="inline-block px-2 py-0.5 bg-accent-500 text-foreground-950 text-xs rounded-full font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}